var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/navigate.adbe6bda.png","uri@2x": __webpack_public_path__ + "static/media/navigate.6d2274b6.png","uri@3x": __webpack_public_path__ + "static/media/navigate.2ed44f4c.png",
    width: 16,
    height: 16
});